import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import {
  Button,
  Dimmer, DropdownProps,
  Form, FormSelect, Grid,
  Header,
  Icon,
  Input,
  Label,
  Loader,
  Pagination, Responsive,
  Table
} from 'semantic-ui-react';
import {CombinedUserDto, fetchUserList, UserPage} from './usermanagement-lib';
import {NavLink} from 'react-router-dom';
import {FilterObjectComponentProps, withFilterObject} from "../../components/DataTable/dataService";
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

interface UserManagementProps extends RouteComponentProps<{}> , FilterObjectComponentProps {
}

interface UserManagementState {
  searchInput: string;
  userStatusFilter: string;
  userPage?: UserPage;
  loading?: boolean;
}

class UserList extends React.Component<UserManagementProps, UserManagementState> {
  constructor(props: UserManagementProps) {
    super(props);

    this.state = {
      searchInput: this.props.filterObject.search || '',
      userStatusFilter: 'all'
    };

    this.onChangeUserStatusFilter = this.onChangeUserStatusFilter.bind(this);
  }

  componentDidMount(): void {
    this.loadData(0);
  }

  componentDidUpdate(prevProps: Readonly<UserManagementProps>, prevState: Readonly<UserManagementState>, snapshot?: any): void {
    if(prevProps.filterObject.userStatusFilter !== this.props.filterObject.userStatusFilter || prevProps.filterObject.search !== this.props.filterObject.search) {
      this.changePage(0);
      this.setState({searchInput: this.props.filterObject.search || ''});
    }
  }

  loadData(page: number = 0) {
    if (this.state.loading) {
      return;
    }
    this.setState({
      loading: true
    }, () => {

      fetchUserList(page, this.props.filterObject.search || '', this.props.filterObject.userStatusFilter || '')
      .then(result => {
        this.setState({userPage: result.data, loading: false});
      }).catch(_ => {
        this.setState({loading: false});
      });
    })
  }

  changePage(page: number) {
    this.loadData(page);
  }

  onChangeUserStatusFilter(ev: any, data: DropdownProps) {
    this.props.handleFilterChange('userStatusFilter', '' + data.value);
  }

  submitSearch() {
    this.props.handleFilterChange('search', this.state.searchInput);
  }

  resetSearch() {
    this.props.handleFilterChange('search', '');
  }

  renderContent() {
    if (!this.state.userPage) {
      return null;
    }
    const routerMatch = this.props.match;

    function getName(userRow: CombinedUserDto) {
      let elements = [];
      if (userRow.identity.attributes && userRow.identity.attributes.company && userRow.identity.attributes.company[0]) {
        elements.push(<span key="company">{userRow.identity.attributes.company[0]}</span>);
      }
      if (userRow.identity.firstName || userRow.identity.lastName) {
        if (elements.length > 0) {
          elements.push(<span key="delimiter"> - </span>);
        }
        elements.push(<span
            key="name">{userRow.identity.firstName} {userRow.identity.lastName}</span>);
      }
      return <>{elements}</>;
    }

    return (<>
      <AnalyticsTracking page="user_management" />

      <Dimmer active={this.state.loading} inverted>
        <Loader/>
      </Dimmer>
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Benutzer-ID</Table.HeaderCell>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Portalnutzer</Table.HeaderCell>
            <Table.HeaderCell/>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {this.state.userPage.content.map(user => (<Table.Row key={user.userId}>
            <Table.Cell>
              <NavLink to={`${routerMatch.path}/${user.userId}`}>
              {user.userId}
              </NavLink>
            </Table.Cell>
            <Table.Cell>
              {getName(user)}
            </Table.Cell>
            <Table.Cell>{user.portalAccount ? <strong>Ja</strong> : 'Nein'}</Table.Cell>
            <Table.Cell>{user.portalAccount && user.portalAccount.userType === 'Z' && user.portalAccount.userRole !== 'A' &&
            <Label color={"blue"}>Anlieferer</Label>}
              {user.portalAccount && user.portalAccount.userType === 'K' && user.portalAccount.userRole !== 'A' &&
              <Label color={"orange"}>Kunde</Label>}
              {user.portalAccount && user.portalAccount.userRole === 'P' &&
              <Label color={"red"}>Premium</Label>}
              {user.portalAccount && user.portalAccount.userRole === 'A' &&
              <Label color={"red"}>Administrator</Label>}
            </Table.Cell>
          </Table.Row>))}
        </Table.Body>
      </Table>
      {(<>

        <Responsive minWidth={768}>
                  <Pagination totalPages={this.state.userPage.totalPages}
                        activePage={this.state.userPage.currentPage + 1}
                         onPageChange={(event, data) => this.changePage(data.activePage ? (+data.activePage - 1) : 0)}/>
        </Responsive>
        <Responsive maxWidth={767}>

          <Button.Group fluid>
            <Button onClick={() => this.changePage(this.state.userPage ? (this.state.userPage.currentPage - 1) : 0)}
                    disabled={this.state.userPage.currentPage <= 0}
                    color="green">⟨</Button>
            <Button basic color="green" >Seite {this.state.userPage.currentPage+1} / {this.state.userPage.totalPages}</Button>
            <Button onClick={() => this.changePage(this.state.userPage ? (this.state.userPage.currentPage + 1) : 0)}
                    disabled={this.state.userPage.currentPage + 1 >= this.state.userPage.totalPages}
                    color="green">⟩</Button>
          </Button.Group>

        </Responsive>

                      </>)}
    </>)
  }

  render() {
    const hasSearch = this.state.userPage && this.state.userPage.search && this.state.userPage.search !== '';
    const routerMatch = this.props.match;

    return (<>
      <div className={"ui container"}>
        <Header as='h1'>
          <Icon name="users"/>
          <Header.Content>
            Benutzerverwaltung
            <Header.Subheader>
              {hasSearch && `Suchergebnisse für "${this.state.userPage ? this.state.userPage.search : ''}".`}
            </Header.Subheader>
          </Header.Content>
        </Header>

        <Grid columns="2" stackable={true}>
          <Grid.Column>
            <NavLink to={`${routerMatch.path}/new`}>
              <Icon name="plus" /> Neuer Benutzer
            </NavLink>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <FormSelect options={[
              {text: 'Alle Benutzer', value: 'all'},
              {text: 'Benutzer mit Portalzugang', value: 'application_access'},
              {text: 'Benutzer ohne Portalzugang', value: 'identity_only'}
            ]} value={this.props.filterObject.userStatusFilter || 'all'}
              onChange={this.onChangeUserStatusFilter}
            />
          </Grid.Column>
        </Grid>
        <p/>
        <Form onSubmit={() => this.submitSearch()}>
          <Input
              fluid
              disabled={this.state.loading}
              action={{
                primary: true,
                disabled: this.state.loading,
                icon: 'search',
                content: 'Suchen',
                type: 'submit'
              }}
              icon={hasSearch ?
                  <Button icon="x" basic type="button" onClick={() => this.resetSearch()}/> : undefined}
              placeholder=""
              value={this.state.searchInput}
              onChange={(_, data) => this.setState({searchInput: data.value})}
          />
        </Form>
        {this.state.loading && <Loader/>}
        {this.renderContent()}
        <br /><br /><br />
      </div>

    </>);
  }
}

export default withFilterObject(withRouter(UserList));